<template>
  <div class="container">
    <div class="row" v-if="serviceRequestStates">
      <ul class="progressbar">
        <li :class="[step.step >= index ? 'active' : '', step.step >= index+1 || step.is_done ? 'background-active' : '']" :attr-key="index"
            v-for="(item, index) in serviceRequestStates" :key="item.id">
          <span class="counter-num">
            <template v-if="step.step >= index+1 || step.is_done">
               <i class="fas fa-check" style="color:white;"></i>
            </template>
            <template v-else>
               {{ index + 1 }}
            </template>
          </span>
          {{ item | multiLangName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    serviceRequestStates: Array,
    step: Object
  }
}
</script>

<style scoped lang="scss">


span.counter-num {
  color: black;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 45%);

  i {
    color: #00BCD4;
  }
}

.progressbar {
  counter-reset: step;
  width: 100%;
}

.progressbar li.background-active:before {
  background: #00BCD4;
}

.progressbar li {
  list-style-type: none;
  width: 33%;
  float: left;
  font-size: 18px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
  left: 0%;
  z-index: 1;
}

.progressbar li:before {
  width: 3rem;
  height: 3rem;
  line-height: 45px;
  border: 3px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
  content: "";
}

.progressbar li:after {
  width: 100%;
  margin-left: 23px;
  height: 2px;
  content: '';
  position: absolute;
  background-color: #7d7d7d;
  top: 22px;
  left: -50%;
  z-index: -1;
}

.progressbar li:first-child:after {
  content: none;
}

.progressbar li.active {
  color: #00BCD4;
}

.progressbar li.active:before {
  border-color: #00BCD4;
}

.progressbar li.active + li:after {
  background-color: #00BCD4;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/ProgressBar.vue